import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLospecComponent } from './simple-icons-lospec.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLospecComponent ],
    exports:      [ SimpleIconsLospecComponent ],
    bootstrap:    []
})
export class SimpleIconsLospecModule {}
